export enum ConfirmDialogImageTypes {
    questionMarkUrl = '../../assets/images/questionMark.png',
    questionExclamationMarkUrl = '../../assets/images/question-exclamation.png',
    thumbsUpUrl = '../../assets/images/thumbsUp.png',
    cancelledPurchaseUrl = '../../assets/images/cancelled-purchase.png',
    warningUrl = '../../assets/images/warning.png',
    warningUrlSvg = '../../assets/images/warningSvg.svg',
  }
